// MenubarMobile.tsx
import { Link } from "react-router-dom";
import React from "react";
import { useUser } from "../contexts/UserContext";
import "./MenubarMobile.css"; // Separate CSS file

export default function MenubarMobile() {
  const { totalShoppingQuantity } = useUser();

  return (
    <nav className="mobile-bottom-nav">
      <div className="mobile-bottom-nav-container">
        {/* Home */}
        <Link to="/" className="mobile-nav-item" title="Начало">
          <img
            src="/assets/img/home.png"
            alt="Начало"
            className="mobile-nav-icon"
          />
        </Link>

        {/* Favorites */}
        <Link to="/favorite" className="mobile-nav-item" title="Любими" data-tutorial="account">
          <img
            src="/assets/img/favorite.png"
            alt="Любими"
            className="mobile-nav-icon"
          />
        </Link>

        {/* Profile */}
        <Link to="/profile" className="mobile-nav-item" title="Профил" data-tutorial="account">
          <img
            src="/assets/img/profile.png"
            alt="Профил"
            className="mobile-nav-icon"
          />
        </Link>

        {/* Shopping List */}
        <Link
          to="/shoppinglist"
          className="mobile-nav-item shopping-list-btn"
          title="Списък за пазаруване"
          data-tutorial="account"
        >
          <img
            src="/assets/img/shopping-list.png"
            alt="Списък за пазаруване"
            className="mobile-nav-icon"
          />
          {totalShoppingQuantity > 0 && (
            <span className="notification-badge">
              {totalShoppingQuantity > 99 ? "99+" : totalShoppingQuantity}
            </span>
          )}
        </Link>
      </div>
    </nav>
  );
}
